export type TAccessTokenClaims = {
	exp?: number;
	sub?: string;
	session_state?: string;
	sid?: string;
};

export const decodeJwtPayload = <T>(token: string): T | null => {
	try {
		const payload = token.split('.')[1];
		if (!payload) return null;
		const json = window.atob(payload.replace(/-/g, '+').replace(/_/g, '/'));
		return JSON.parse(json) as T;
	} catch {
		return null;
	}
};

export const readSubject = (accessToken: string | null): string | null => {
	if (!accessToken) return null;
	return decodeJwtPayload<TAccessTokenClaims>(accessToken)?.sub ?? null;
};

/** Keycloak realm roles of the token (`realm_access.roles`), e.g. `paymentgateway_admin`. */
export const readRealmRoles = (token: string): string[] =>
	decodeJwtPayload<{ realm_access?: { roles?: string[] } }>(token)?.realm_access?.roles ?? [];
